import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      &copy;{year} Kammaṭṭhānasamuṭṭhāpaka Nikāya | Tumbuh Setiap Saat Menjadi Tercerahkan dan Sempurna
    </footer>
  );
};

export default Footer;
